import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';

// Kept apart from App.tsx so the stores can reach the Okta client without
// importing the app shell, which would pull every container into their graph.
const BASENAME = import.meta.env.BASE_URL || '';
const REDIRECT_URI = `${window.location.origin}${BASENAME}login/callback`;
const REACT_APP_OKTA_CLIENT_ID = import.meta.env.REACT_APP_OKTA_CLIENT_ID;
const REACT_APP_OKTA_ISSUER = import.meta.env.REACT_APP_OKTA_ISSUER;

if (!REACT_APP_OKTA_CLIENT_ID || !REACT_APP_OKTA_ISSUER) {
    throw new Error('Missing Okta configuration in environment variables');
}

type RestoreOriginalUri = (
    oktaAuth: unknown,
    originalUri?: string
) => Promise<void>;

export const restoreOriginalUri: RestoreOriginalUri = async (
    _oktaAuth,
    originalUri
) => {
    window.location.replace(
        toRelativeUrl(originalUri || '/', window.location.origin)
    );
};

export const oktaAuth = new OktaAuth({
    clientId: REACT_APP_OKTA_CLIENT_ID,
    issuer: REACT_APP_OKTA_ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    postLogoutRedirectUri: `${window.location.origin}${BASENAME}/login`,
    restoreOriginalUri,
});
